import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 0,
			gcTime: 1000 * 60 * 5, // 5 minutes
			retry: 2,
			refetchOnMount: true,
			refetchOnWindowFocus: true,
			refetchOnReconnect: true,
			refetchInterval: false
		}
	}
});

const GlobalReactQueryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
	<QueryClientProvider client={queryClient}>
		{children}
		<div style={{ fontSize: '20px' }}>
			<ReactQueryDevtools initialIsOpen={false} />
		</div>
	</QueryClientProvider>
);
export default GlobalReactQueryProvider;
